import { createContext } from "react";

export const DeebContext = createContext({});
